import type { WidgetConfig } from '../schemas';

type Row = Record<string, string | number>;

interface WidgetProps {
  config: WidgetConfig;
  data: { current: Row[]; previous: Row[] | null; meta: any } | null;
  loading?: boolean;
  error?: string;
}

export default function DividerWidget(_props: WidgetProps) {
  return (
    <div className="h-full flex items-center">
      <hr className="border-t border-[#E2E4ED] w-full" />
    </div>
  );
}
